<template>
    <div class="p-6 pt-2 pb-4">
        <div
            :class="[
                'w-auto p-4 rounded-md border flex-col justify-start items-start inline-flex bg-white flex-col justify-start items-start gap-2 inline-flex',
                classes,
            ]">
            <div
                class="self-stretch mb-2 flex-col justify-start items-start gap-1 flex"
                v-if="label">
                <div
                    v-if="label || subtext"
                    class="self-stretch justify-start items-start gap-1 inline-flex gap-2">
                    <Icon
                        class="mr-2"
                        :icon="icon"
                        alt="Notifications" />

                    <div>
                        <div
                            v-if="label"
                            class="text-neutral-900 text-base font-bold font-Open-Bold">
                            {{ label }}
                        </div>
                        <div
                            v-if="subtext"
                            class="self-stretch text-zinc-800 text-sm font-normal font-Open leading-tight max-584 gap-2"
                            v-html="subtext"></div>
                    </div>
                </div>
            </div>

            <div
                class="self-stretch justify-start items-start gap-6 inline-flex gap-2 pl-[40px]">
                <div
                    class="grow shrink basis-0 mr-6 self-stretch flex-col justify-center items-start inline-flex"
                    v-for="(item, key, index) in items"
                    :key="key">
                    <label
                        :for="item.name"
                        :class="[
                            'self-stretch justify-start items-start gap-2 inline-flex cursor-pointer relative',
                            item.classes,
                        ]">
                        <input
                            type="checkbox"
                            :value="item.name"
                            :name="item.name"
                            @change="handleCheckboxChange($event, item.name)"
                            :checked="item.checked"
                            class="opacity-0 top-0 bottom-0 right-0 left-0 block absolute width-full height-full z-20 cursor-pointer" />

                        <div class="special-request-checkbox"></div>
                        {{ item.label }}
                    </label>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { useBookingStore } from '@/stores/booking';
    const { state, updateBookingState } = useBookingStore();
    const props = defineProps({
        label: String,
        subtext: String,
        classes: String,
        items: Array,
        icon: String,
    });

    const handleCheckboxChange = (event: Event, itemName: string) => {
        const { checked } = event.target as HTMLInputElement;

        if (state.country_code !== 'US') {
            updateBookingState({
                whatsapp_service_consent: checked,
                sms_service_consent: checked,
            });
        } else {
            updateBookingState({
                [itemName]: checked,
            });
        }
    };
</script>
